import { BasePresenter } from "@presenters/base/base.presenter";
import { useSelector } from "react-redux";
import { ILang } from "@models/*";
import { Dictionary, Utilities, Enums, queryString } from "@utils";
import { FollowupService, IFollowupService } from "@services/proyecta/followup.service";
import DataGrid from "devextreme/ui/data_grid";

export class ByProjectPresenter extends BasePresenter<any> {
    public currentLabels: Dictionary<string, string>;
    public followupLabels: Dictionary<string, string>;
    public formMasters: any;
    public infoByProject: any[]
    public currentLang: ILang;
    private followupService: IFollowupService;
    public params: any;
    
    constructor(view: any) {
        super(view);
        this.formMasters = useSelector(this.context.followupStore.selectFormMasters);
        this.currentLabels = useSelector(this.context.sessionStore.selectLabels);
        this.followupLabels = useSelector(this.context.followupStore.selectLabels);
        this.infoByProject = useSelector(this.context.followupStore.selectInfoByProject);
        this.currentLang = useSelector(this.context.sessionStore.selectLang) as any;
        this.params = useSelector(this.context.sessionStore.selectParams);

        this.saveData = this.saveData.bind(this);

        this.followupService = new FollowupService();
    }

    public async initByProject(reload?: boolean){ 
        this.dispatcherPendingLoad(1);
        this.dispatcherSetLoading();

        this.dispatcherProgress(50); 

        const {Code} = this.getParamId()
        this.dispatcher(this.context.followupStore.getInfoByProject(Code));

        this.dispatcherProgress(60); 

        this.dispatcher(this.context.followupStore.getLabels()); 
        this.dispatcher(this.context.followupStore.getAllFormMasters()); 

        const columns = await this.followupService.getDefinitionColumnsIndex(this.currentLang?.id);
        this.dispatcherProgress(80);  

        this.view.state.setDataColumns(columns);
    }

    public async clear(){
        this.dispatcher(this.context.followupStore.getInfoByProject(null));
    }

    public async unSetLoading(){
        setTimeout(() => {
            let labelProgress = document.getElementById('labelProgress');
            if(labelProgress){
                let myBar = document.getElementById('myBar');
                labelProgress.innerText = '90%';
                myBar.style.width = '90%'; 
            }
        }, 400);
        setTimeout(() => {
            this.dispatcherUnsetSetLoading();
        }, 1000);
    }

    public getTotalPermissions(projectData: any){
        const TEAM_CENTRAL = this.params[Enums.Params.proyectaCentralTeam]
        const ADMIN_GROUP = this.params[Enums.Params.proyectaAdminModule]

        let countryRegionGroup: string = !!projectData?.IdPais 
            ? this.formMasters.countries.find((x: any) => x.Id === Number(projectData?.IdPais))?.SGGrupoAD 
            : this.formMasters.regions.find((x: any) => x.Id === Number(projectData?.IdRegion))?.SGGrupoAD
        
        let userGroupsId: any[] = this?.currentUser?.userGroups?.map((x: any) => x.id)
        let userGroupsName: any[] = this?.currentUser?.userGroups?.map((x: any) => x.displayName)

        return (userGroupsName?.includes(TEAM_CENTRAL) || userGroupsName?.includes(ADMIN_GROUP) || userGroupsId?.includes(countryRegionGroup))
    }

    public getProjectData(infoByProject: any){ 
        const { Year } = this.getParamId()
        let indexData = infoByProject?.indexData?.find((a: any) => (!!a.IdLineaIntervencion && !!a.TituloProyecto && Year === a.Anio))
        let auxData: any = null

        if(!!indexData){
            const interventionLine = this.formMasters.interventionLines.find((x: any) => x.Id === Number(indexData.IdLineaIntervencion))?.Title
            const description = ((indexData.PPresCodProy || '') + ' - ' + (indexData.TituloProyecto || '') + ' - ' + (indexData.Anio || ''))
            auxData = {
                interventionLine,
                Title: indexData.TituloProyecto || '',
                PPresCodProy: indexData.PPresCodProy || '',
                Anio: indexData.Anio || '',
                description,
                IdPais: indexData.IdPais,
                IdRegion: indexData.IdRegion,
            }
        }

        return auxData
    }

    public getOverlapByProject(infoByProject: any){ 
        let disaggData = infoByProject?.disaggregation || []
        const { Code, Year } = this.getParamId()
        let auxData: any = []

        for (const info of disaggData) {
            if(info.SubProyectoAnio?.Anio === Year && info.SubProyectoAnio?.PPresCodProy === Code){
                if(!info.SubProyectoAnio?.CodigoSubvencion){
                    auxData.unshift({
                        id: info.SubProyectoAnioId,
                        bySubproject: "FFRR",
                        byBeneficiaries: info.PFFRRTotal,
                    })
                }else{
                    auxData.push({
                        id: info.SubProyectoAnioId,
                        bySubproject: info.SubProyectoAnio?.CodigoSubvencion,
                        byBeneficiaries: info.PFFRRTotal,
                    })
                }
            }
        }

        for (let i = 0; i < auxData.length; i++) {
            const element = auxData[i];
            element.overlaps = []
            for (let j = i+1; j < auxData.length; j++) {
                let dataSaved = infoByProject?.byProjectOverlap?.find((x: any) => x.SubProyectoAnioId === auxData[j].id && x.SegBenefParentId === element.id)

                const overlapEl: any = {
                    id: auxData[j].id,
                    SegBenefParentId: element.id,
                    bySubproject: auxData[j].bySubproject,
                    byBeneficiaries: dataSaved?.TotalBeneficiarios,
                    relatedId: dataSaved?.Id
                };
                element.overlaps.push(overlapEl)
            }
        }
        return auxData
    }

    public getOverlapSum(overData: any[]){
        let overlapValues = []
        let overlapCount = 0
        let overlapSum = 0

        for (const over of overData) {
            let overlaps = over.overlaps
            for (const child of overlaps) {
                if(!Utilities.isNullEmptyObject(child.byBeneficiaries) && child.byBeneficiaries > 0){
                    overlapValues.push(child.byBeneficiaries)
                    overlapCount++
                }
            }
        }

        overlapValues = overlapValues.sort((a: number, b: number) => a < b ? 1 : a > b ? -1 : 0)
        let itemsToSum = (overlapCount > 0) ? ((overlapCount/2) + 1) : 0

        if(itemsToSum > 0){
            itemsToSum = Math.floor(itemsToSum)
            for (let i = 0; i < itemsToSum; i++) {
                overlapSum += (overlapValues[i] || 0)
            }
        }

        return overlapSum
    }

    public getBeneficiariesByProject(infoByProject: any, beneficiariesDup: any[], overData: any[], currentData: any[]){
        let overlapSum = this.getOverlapSum(overData)

        let total = ((beneficiariesDup?.[2]?.value || 0) - overlapSum)
        let SubProjectosAnio = beneficiariesDup?.[2]?.SubProjectosAnio || []

        const areIncludes = (element: any) => SubProjectosAnio.includes(element);
        let dataSaved = infoByProject?.benData?.find((x: any) => x.SubProyectosAnioId?.some(areIncludes))

        let benData: any = []
        if(currentData?.length){
            currentData[0].auxTotal = total
            currentData[1].auxTotal = total
            currentData[2].auxTotal = total
            benData = currentData
        }else{
            benData = [
                {
                    description: this.followupLabels.get('menFollowupBy'),
                    value: dataSaved?.PFFRRTotalHombres,
                    auxTotal: total
                },
                {
                    description: this.followupLabels.get('womenFollowupBy'),
                    value: dataSaved?.PFRRTotalMujeres,
                    auxTotal: total
                },
                {
                    description: this.followupLabels.get('totalFollowupBy'),
                    value: total,
                    auxTotal: total,
                    SubProjectosAnio,
                    relatedId: dataSaved?.Id
                }
            ]
        }

        return benData
    }

    public getBeneficiariesDupByProject(infoByProject: any){ 
        let disaggData = infoByProject?.disaggregation || []
        const { Code, Year } = this.getParamId()
        let benData: any = []
        let SubProjectosAnio: number[] = []

        let men = 0, women = 0, total = 0

        for (const info of disaggData) {
            if(info.SubProyectoAnio?.Anio === Year && info.SubProyectoAnio?.PPresCodProy === Code){
                SubProjectosAnio.push(info.SubProyectoAnioId)
                men += (info.PFFRRTotalHombres || 0)
                women += (info.PFRRTotalMujeres || 0)
                total += (info.PFFRRTotal || 0)
            }
        }

        SubProjectosAnio = SubProjectosAnio.sort((a: number, b: number) => a > b ? 1 : a < b ? -1 : 0)

        benData = [
            {
                description: this.followupLabels.get('menFollowupBy'),
                value: men,
                percent: (men/total)
            },
            {
                description: this.followupLabels.get('womenFollowupBy'),
                value: women,
                percent: (women/total) 
            },
            {
                description: this.followupLabels.get('totalDupFollowupBy'),
                value: total,
                percent: (total/total),
                SubProjectosAnio,
            }
        ]
        
        return benData
    }

    public async saveData(step: any){
        const { Code } = this.getParamId()
        let currUser = this.currentUser.currentUser.userPrincipalName
        let overData = this.view.state.overData
        let benData = this.view.state.benData

        Utilities.showLoading(this.followupLabels.get("savingMessage"), this.followupLabels.get("loadingMessage"))

        if(step === 1){
            let itemOverAdd = [], itemOverUpd = [], itemAdd = [], itemUpd = [], isValid = false, hasError = false

            if(overData?.overlap?.length){
                for (const overlap of overData.overlap) {
                    let overlaps = overlap?.overlaps || []
                    for (const byOver of overlaps) {
                        if(!hasError) hasError = this.getTableInstance(`overlaps-detail-${overlap.id}`)?.hasEditData()
                        let itemToSave: any = {
                            TotalBeneficiarios: byOver.byBeneficiaries,
                            SubProyectoAnioId: byOver.id,
                            SegBenefParentId: byOver.SegBenefParentId,
                            PPresCodProy: Code
                        }
                        if(!byOver?.relatedId){
                            itemOverAdd.push(itemToSave)
                        }else{
                            itemToSave.Id = byOver.relatedId
                            itemOverUpd.push(itemToSave)
                        }
                    }
                }
            }

            if(benData?.beneficiaries?.length){
                let byBen = benData?.beneficiaries
                let SubProyectosAnioId = this.createLookupObjectMultiValue(byBen[2]?.SubProjectosAnio)
                let itemToSave: any = {
                    PFFRRTotalHombres: byBen[0]?.value,
                    PFRRTotalMujeres: byBen[1]?.value,
                    TotalBeneficiarios: byBen[2]?.value,
                    PPresCodProy: Code,
                    SubProyectosAnioId
                }
                if(!byBen[2]?.relatedId){
                    itemAdd.push(itemToSave)
                }else{
                    itemToSave.Id = byBen[2].relatedId
                    itemUpd.push(itemToSave)
                }

                if(!isValid) isValid = ((itemToSave?.PFFRRTotalHombres || 0) + ((itemToSave?.PFRRTotalMujeres || 0)) === itemToSave?.TotalBeneficiarios)
            }

            if(isValid && !hasError){
                let returnIdsAll = await Promise.all([
                    this.followupService.addIndexFollowup(itemOverAdd, Enums.ListTypes.FollowupByProjectOverlap, currUser),
                    this.followupService.addIndexFollowup(itemAdd, Enums.ListTypes.FollowupBenByProject, currUser),
                    this.followupService.updateIndexFollowup(itemUpd, Enums.ListTypes.FollowupBenByProject, currUser),
                    this.followupService.updateIndexFollowup(itemOverUpd, Enums.ListTypes.FollowupByProjectOverlap, currUser),
                ]);
    
                let returnOverIds = returnIdsAll[0];
                let returnIdBens = returnIdsAll[1];
    
                for (const added of returnOverIds) {
                    let createdId = added.data.Id;
                    let parentId = added.data.SegBenefParentId;
                    let SubProyectoAnioId = added.data.SubProyectoAnioId;
                    overData.overlap.filter((a:any) => a.id == parentId)[0].overlaps.filter((a:any) => a.id == SubProyectoAnioId)[0].relatedId = createdId
                }
    
                for (const added of returnIdBens) {
                    let createdId = added.data.Id;
                    benData.beneficiaries[2].relatedId = createdId
                }

                Utilities.notifySuccess(this.currentLabels.get("Guardado exitoso"), this.currentLabels.get("Guardar"))

            }else{
                if(hasError){
                    Utilities.notifyError(this.followupLabels.get('errorEditData'))
                }else{
                    Utilities.notifyError(this.followupLabels.get('followupByError'))
                }
            }
        }
    }

    public getOverlapColumns(){
        const {Year} = this.getParamId()
        return [
            this.getCommonFieldProps("bySubproject"),
            this.getCommonFieldProps("byBeneficiaries", Year)
        ]
    }

    public getBeneficiariesByColumns(){
        return [
            {
                dataField: "description",
                allowEditing: true,
                alignment: "center"
            },
            {
                dataField: "value",  
                dataType: "number",
                allowEditing: true,
                alignment: "center"
            },
            {
                dataField: "percent",  
                dataType: "number",
                format: "% #",
                allowEditing: true,
                alignment: "center",
                calculateCellValue: (data: any) => this.getPercentValue(data)
            }
        ]
    }

    public getCommonFieldProps(fieldName: string, year?: string) {
        const fieldProps = this.view.state.dataColumns.get(fieldName);
        const field: any = {
          id: `${fieldProps?.Id || 0}_followup`,
          caption: fieldProps?.OCTAVIAValorTraduccion || "",
          dataField: fieldProps?.Title || "",
          dataType: fieldProps?.OCTAVIATipoCampo || "string",
          allowEditing: !fieldProps?.SoloLectura,
          alignment: fieldProps?.Alineacion || "center",
          visible: fieldProps?.OCTAVIAVisible || false,
        };

        if(fieldName === Enums.FollowupBasicFields.byBeneficiaries){
            field.caption += ` ${year}`
        }
        
        return field;
    }

    public validateOverlapDetail(e: any, pivot: any, overData: any){
        let myData = overData.find((x: any) => x.id === e.data.id)
        let result: boolean = (e.value <= (pivot[e.column.dataField] || 0) && e.value <= (myData[e.column.dataField] || 0))

        return result
    }

    public getPercentValue(data: any){
        if(!Utilities.isNullObject(data?.auxTotal)){
            let result = ((data?.value || 0) / (data?.auxTotal || 0))
            return isFinite(result) ? result : 0
        }else{
            return data?.percent
        }
    }

    public getParamId(){
        const query = queryString.parseUrl(window.location.href.replace('#', '')).query as any;
        return query
    }

    public createLookupObjectMultiValue(values: any) {
        return { '__metadata': { type: 'Collection(Edm.Int32)' }, results: values ? values : [] };
    }

    public getTableInstance(tableId: string): DataGrid {
        let element = document.getElementById(tableId);
        if (Utilities.isNullEmptyObject(element)) {
          return null;
        }
    
        return DataGrid.getInstance(element) as DataGrid;
    }
}

export default ByProjectPresenter;
